module.exports = __webpack_public_path__ + "static/media/dashboard-alert.1716f8b0.svg";